import { render, staticRenderFns } from "./ChainsBonusGame.vue?vue&type=template&id=09b854dd&lang=pug&"
import script from "./ChainsBonusGame.vue?vue&type=script&lang=js&"
export * from "./ChainsBonusGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports